(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const bindCards = () => document.querySelectorAll('[data-card-variant]').forEach(button => {
    if (button.dataset.bound) return;
    button.dataset.bound = 'true';
    button.addEventListener('click', () => {
      const card = button.closest('[data-product-card]');
      const image = card.querySelector('.product-card-image img');
      image.removeAttribute('srcset');
      image.src = button.dataset.image;
      card.querySelectorAll('a').forEach(link => { link.href = button.dataset.url; });
      card.querySelector('[data-card-price]').textContent = button.dataset.price;
      card.querySelectorAll('[data-card-variant]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
    });
  });
  bindCards();
  const bindDrawings = () => document.querySelectorAll('[data-drawing-video]').forEach(video => {
    if (video.dataset.bound || reduced.matches) return;
    video.dataset.bound = 'true';
    const container = video.parentElement;
    const button = container.querySelector('[data-drawing-play]');
    const fallback = () => {
      container.classList.remove('is-playing');
      container.classList.add('is-static');
      button.hidden = reduced.matches || Boolean(video.error);
    };
    const play = () => {
      video.muted = true;
      video.defaultMuted = true;
      video.play().catch(fallback);
    };
    video.addEventListener('playing', () => {
      container.classList.remove('is-static');
      container.classList.add('is-playing');
      button.hidden = true;
    });
    video.addEventListener('error', fallback);
    button.addEventListener('click', play);
    if (reduced.matches) return;
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting) || reduced.matches) return;
      play();
      observer.unobserve(video);
    }, {threshold:.2});
    observer.observe(video);
  });
  bindDrawings();
  document.querySelectorAll('[data-variant-select]').forEach(variant => variant.addEventListener('change', () => {
    const selected = variant.form.querySelector('[data-product-variant]');
    if (!variant.checked || variant.value === selected?.value) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.value);
    window.location.assign(url);
  }));
  const dialog = document.querySelector('[data-zoom-dialog]');
  if (dialog && typeof dialog.showModal === 'function') {
    document.querySelectorAll('[data-zoom]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      dialog.querySelector('img').src = link.href;
      dialog.showModal();
    }));
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  }
  let materialScenes = document.querySelectorAll('[data-material]');
  let scrollStages = document.querySelectorAll('[data-scroll-stage]');
  let hero = document.querySelector('[data-hero]');
  const phase = (progress, start, end) => {
    const value = Math.min(1, Math.max(0, (progress - start) / (end - start)));
    return value * value * (3 - 2 * value);
  };
  const paintInlay = (stage, section, progress) => {
    const lift = phase(progress, .38, .58) * (1 - phase(progress, .74, .86));
    stage.style.setProperty('--camera', String(1 + (phase(progress, 0, .22) - phase(progress, .85, 1)) * (innerWidth > 760 ? 1.3 : 1.05)));
    stage.style.setProperty('--lift', String(lift * (innerWidth > 760 ? 1 : .7)));
    stage.style.setProperty('--patch', String(Math.min(1, lift * 8)));
    const step = progress < .2 ? 0 : progress < .4 ? 1 : progress < .84 ? 2 : 3;
    section.querySelectorAll('[data-scene-panel]').forEach((panel, index) => {
      panel.classList.toggle('is-active', index === step);
      panel.setAttribute('aria-hidden', String(index !== step));
    });
    const buttons = section.querySelectorAll('[data-scene-jump]');
    buttons.forEach((button, index) => { if (index === step) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
    const scrub = section.querySelector('[data-scene-progress]');
    if (scrub) {
      scrub.value = String(Math.round(progress * 1000));
      scrub.setAttribute('aria-valuetext', `${Math.round(progress * 100)}% · ${buttons[step]?.textContent.trim() || ''}`);
    }
  };
  const bindInlay = () => document.querySelectorAll('[data-immersive]').forEach(stage => {
    if (stage.dataset.bound) return;
    stage.dataset.bound = 'true';
    const section = stage.closest('.craft-section');
    const jump = progress => {
      if (reduced.matches) return;
      const rect = section.getBoundingClientRect();
      const value = Math.min(1, Math.max(0, progress));
      window.scrollTo({ top: rect.top + window.scrollY + value * Math.max(1, rect.height - innerHeight), behavior: 'instant' });
      paintInlay(stage, section, value);
    };
    section.querySelectorAll('[data-scene-jump]').forEach(button => button.addEventListener('click', () => jump(Number(button.dataset.sceneJump))));
    section.querySelector('[data-scene-progress]')?.addEventListener('input', event => jump(Number(event.target.value) / 1000));
  });
  bindInlay();
  let pending = false;
  const update = () => {
    pending = false;
    if (reduced.matches) return;
    if (hero && innerWidth > 760) {
      const rect = hero.getBoundingClientRect();
      if (rect.bottom >= 0) hero.style.setProperty('--hero-shift', `${Math.min(1, Math.max(0, -rect.top / rect.height)) * 55}px`);
    }
    scrollStages.forEach(stage => {
      const section = stage.closest('.craft-section');
      const rect = section.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const progress = Math.min(1, Math.max(0, -rect.top / Math.max(1, rect.height - innerHeight)));
      if (stage.hasAttribute('data-immersive')) { paintInlay(stage, section, progress); return; }
      stage.style.setProperty('--zoom', String(1 + progress * .16));
      stage.style.setProperty('--detail', String(Math.min(1,Math.max(0,(progress - .15) * 2.4))));
      stage.style.setProperty('--focus', String(1 + Math.min(1, progress / .65) * (innerWidth > 760 ? 1.15 : .5)));
      stage.style.setProperty('--atelier', `${Math.min(1, Math.max(0, (progress - .68) / .28)) * 100}%`);
      section.querySelectorAll('.craft-steps li').forEach((item, index) => { item.style.opacity = index === Math.min(2, Math.floor(progress * 3)) ? '1' : '.5'; });
      const video = stage.querySelector('[data-scroll-video]');
      if (video && innerWidth > 760) {
        if (video.preload === 'none') { video.preload = 'metadata'; video.load(); }
        if (Number.isFinite(video.duration) && !video.seeking) video.currentTime = progress * video.duration;
      }
    });
    materialScenes.forEach(chapter => {
      const rect = chapter.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const progress = Math.min(1,Math.max(0,-rect.top/Math.max(1,rect.height-innerHeight)));
      chapter.style.setProperty('--material-zoom',String(1.02+phase(progress,0,1)*(innerWidth>760?.68:.4)));
      chapter.style.setProperty('--material-shift',`${-progress*24}px`);
    });
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  document.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', () => { materialScenes = document.querySelectorAll('[data-material]'); scrollStages = document.querySelectorAll('[data-scroll-stage]'); hero = document.querySelector('[data-hero]'); bindInlay(); bindCards(); bindDrawings(); schedule(); });
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      document.querySelectorAll('[data-drawing-video]').forEach(video => { video.pause(); video.parentElement.classList.remove('is-playing'); video.parentElement.querySelector('[data-drawing-play]').hidden = true; });
      scrollStages.forEach(stage => { ['--zoom', '--detail', '--focus', '--atelier', '--camera', '--lift', '--patch'].forEach(key => stage.style.removeProperty(key)); if (stage.hasAttribute('data-immersive')) paintInlay(stage, stage.closest('.craft-section'), 0); const video = stage.querySelector('video'); if (video) video.pause(); });
      materialScenes.forEach(chapter => { chapter.style.removeProperty('--material-zoom'); chapter.style.removeProperty('--material-shift'); });
      if (hero) hero.style.removeProperty('--hero-shift');
    }
    else { bindDrawings(); schedule(); }
  });
  schedule();
})();
